//Oculus Quest Controller Models by Jezza3D on Sketchfab with small adjustments made by me